import CounterContext from 'contexts/counter'
import { useCallback, useContext, useEffect, useRef } from 'react'
export default function ScrollContainer({ children }: { children: any }) {
   const ref = useRef<any>(undefined)
   const { setCounter, counterDefault } = useContext(CounterContext)
   const div = ref.current
   const handleScroll = useCallback(() => {
      setCounter(counterDefault)
   }, [])
   useEffect(() => {
      div?.addEventListener('scroll', handleScroll)
   }, [handleScroll, div])
   return (
      <div className='scroll' ref={ref}>
         {children}
      </div>
   )
}
